module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_9006.8850bfc6.png";